// import moment from 'moment'
import axios from 'axios'

export const state = () => []

export const getters = {
  activeTopOffer (state, getters, rootState) {
    // const currentDate = moment()
    // const validOffers = state.filter(offer => {
    //   return offer.status === 'active' && moment(offer.created_at).diff(currentDate, 'minutes') < 0 && moment(offer.expires_at).diff(currentDate, 'minutes') > 0
    // })

    const offer = state.find(o => o.position === 'offer-top')
    if (offer && rootState.settings.offersClosed.indexOf(offer.campaign) === -1) {
      return offer
    }

    return false
  },
  activeBottomOffer (state) {
  }
  // isVisible (state, getters, rootState) {
  //   return getters.activeOffer && rootState.settings.offersClosed.indexOf(getters.activeOffer.id) === -1
  // }
}

export const mutations = {
  setOffers (state, offers) {
    offers.map(offer => state.push(offer))
  }
}

export const actions = {
  async fetch ({ commit }) {
    const hooks = await axios({
      url: `${process.env.VUE_APP_AIRTABLE_API}/hooks.json`,
      method: 'get'
    })

    commit('setOffers', hooks.data.filter(h => h.product === 'plugin'))
  }
}
